/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询PC演出分类楼层项目,不够9条自动获取当前分类其他项目补全
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.FloorProductsDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/floor/products`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
